import axios, { AxiosResponse } from 'axios';
import { IDropdownResponse } from '../models';

import { authFetch } from './fetch';
const baseUrl = '/api/Admin/Teams';

export const getTeams = async (): Promise<IDropdownResponse[]> => {
  try {
    const response: AxiosResponse<IDropdownResponse[]> = await authFetch.get(`${baseUrl}`);
    return response.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      return Promise.reject(err?.response?.data);
    }
    return Promise.reject(err);
  }
};
